<div class="loader">
  <div class="loader__content">
    <img src="/assets/images/as_promoad_promoting_loader.gif" />
    <h4>{{ text }}</h4>
    <p>{{ "shared.pleaseWait" | translate }}</p>
  </div>
</div>
